/* Datei: src/pages/BlogAdmin/BlogAdmin.js */
import React, { useState } from 'react';
import KeywordManagement from './KeywordManagement';
import BlogGenerator from './BlogGenerator';
import BlogManagement from './BlogManagement';
import AdminPageFrame from '../../components/admin/AdminPageFrame';
import './BlogAdmin.css';

const BlogAdmin = () => {
  const [activeTab, setActiveTab] = useState('keywords'); // 'keywords', 'generator', 'management'

  return (
    <AdminPageFrame
      title="Blogverwaltung"
      subtitle="Keywords, Generierung und Management laufen jetzt im gemeinsamen Admin-Arbeitsraum."
      badge="Content Operations"
    >
      <div className="blog-admin">
        <header className="blog-admin-header">
          <div>
            <h1>Blogverwaltung</h1>
            <p className="blog-admin-section-copy">
              Keyword-Steuerung, Artikelerzeugung und Pflege folgen jetzt derselben Admin-Flaechenlogik.
            </p>
          </div>
          <nav className="blog-admin-tabs">
            <button className={`blog-admin-tab${activeTab === 'keywords' ? ' active' : ''}`} onClick={() => setActiveTab('keywords')}>
              Keywords setzen
            </button>
            <button className={`blog-admin-tab${activeTab === 'generator' ? ' active' : ''}`} onClick={() => setActiveTab('generator')}>
              Blogs generieren
            </button>
            <button className={`blog-admin-tab${activeTab === 'management' ? ' active' : ''}`} onClick={() => setActiveTab('management')}>
              Blog verwalten
            </button>
          </nav>
        </header>
        <main className="blog-admin-section">
          {activeTab === 'keywords' && <KeywordManagement />}
          {activeTab === 'generator' && <BlogGenerator />}
          {activeTab === 'management' && <BlogManagement />}
        </main>
      </div>
    </AdminPageFrame>
  );
};

export default BlogAdmin;
